import React, { useEffect, useState } from 'react';
import config from '../../config/config';
import uploadFile from '../../utilities/uploadFile';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function EditRecipientsForm() {
  // for file upload
  const [uploadFiles, setUploadFiles] = useState(null);

  // let isReady = updateData !== undefined
  let { email_subject } = useParams();
  let { date_time } = useParams();
  let { email_id } = useParams();

  async function getAllContacts() {
    await axios
      .get(config.apiURL + `/contacts_not_emailed/email_id/${email_id}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        const tempArr = [];
        const tempRef = [];
        response.data.map((x) => {
          return tempArr.push(x.email_address);
        });
        response.data.map((x) => {
          return tempRef.push({
            email_address: x.email_address,
            poc_id: x.poc_id
          });
        });
      });
  }

  async function getRecipientEmails() {
    await axios
      .get(config.apiURL + `/contacts_emailed/email_id/${email_id}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        const tempArr = [];
        const tempRef = [];
        response.data.map((x) => {
          return tempArr.push(x.email_address);
        });

        response.data.map((x) => {
          return tempRef.push({
            email_address: x.email_address,
            poc_id: x.poc_id
          });
        });
      });
  }

  const myChangeHandler = (event) => {
    let nam = event.target.name;

    if (nam === 'files') {
      setUploadFiles(event.target.files);
    }
  };

  async function addEmailFiles(e) {
    e.preventDefault();
    for (let i = 0, numFiles = uploadFiles.length; i < numFiles; i++) {
      const file = uploadFiles[i];
      const s3Key = `/outreach/emails/${email_id}/${file.name}`;
      let r = await uploadFile(s3Key, file);
      console.log(r);
    }
    window.location.reload();
  }

  useEffect((loadingData) => {
    getAllContacts();
    getRecipientEmails();

    if (loadingData) {
      //if the result is not ready so you make the axios call
      getAllContacts();
      getRecipientEmails();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='container all-center'>
      <h3 id='email_name' style={{ width: '400px', marginLeft: '35px' }}>
        {email_subject} <br /> {date_time.substring(0, 10)}
      </h3>
      <div
        className='card text-center'
        style={{ background: '#54c5f1', width: '500px' }}
      >
        <h4 id='email_id' style={{ width: '400px', marginLeft: '35px' }}>
          Edit Recipient Information
        </h4>
        <div className='grid-container' style={{ width: '465px' }}>
          <div className='grid-item'>
            <form id='addEmailFiles' onSubmit={addEmailFiles}>
              <label>Notes</label>
              <textarea
                id='notes'
                name='notes'
                onChange={myChangeHandler}
                style={{
                  width: '100%',
                  marginBottom: '10px',
                  resize: 'vertical',
                  maxHeight: '200px'
                }}
              />
              <label>Upload files</label>
              <br />
              <i>* hold CRTL/CMD to select multiple files</i>
              <input
                type='file'
                id='files'
                name='files'
                multiple
                onChange={myChangeHandler}
                style={{
                  backgroundColor: 'white',
                  width: '100%',
                  marginBottom: '10px'
                }}
              />
              <button
                className='btn btn-primary'
                type='submit'
                id='addEmailDocBtn'
                style={{ width: '60px', fontSize: 'x-small' }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditRecipientsForm;
